import styled from "styled-components";
import {Brand} from "nav/normal/NavBar.styles";

/** The app's CssBaseline may never have mounted, so this surface owns its entire background. */
export const ErrorBackdrop = styled.div`
	min-height: 100vh;
	background: ${({theme}) => theme.tokens.paper};
`;

/** The existing brand presentation, without introducing a navigation control during recovery. */
export const ErrorBrand = styled(Brand).attrs({as: "div"})`
	cursor: default;
	margin-bottom: 20px;
`;
